import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AppService, GRSSResponse, ValueIdPair } from 'src/app/_services/app.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

  currentTime: string;
  intervals: any[] = [];
  azureEnabled: boolean = false;

  @Output() toggleSidebar: EventEmitter<any> = new EventEmitter();

  constructor(@Inject('BASE_URL') public baseUrl: string, private http: HttpClient, public router: Router, public service: AppService, private msalService: MsalService) { }

  ngOnInit() {
    
    const details = this.msalService.instance.getActiveAccount();
    if (details) {
      this.azureEnabled = true;
    }
    this.GetTime(-1);
    let seconds: number = 60 - new Date().getSeconds();
    setTimeout(() => {
      this.GetTime(seconds);
      const interval = setInterval(() => {
        seconds = new Date().getSeconds();
        if (seconds > 30) {
          seconds = 60 - seconds;
        } else if (seconds < 30) {
          seconds = 30 - seconds;
        }
        this.GetTime(seconds);
      }, seconds * 1000);
      this.intervals.push(interval);
    }, seconds * 1000);
  }
  
  ngOnDestroy() {
    if (this.intervals.length > 0) {
      this.intervals.forEach(interval => {
        clearInterval(interval);
      });
    }
  }

  /** emmiting an event */
  toggleBar() {
    this.toggleSidebar.emit();
  }

  logout() {
    this.router.navigate(['logout']);
  }


  onChangeUser(role: ValueIdPair) {
    if (role.id != this.service.currentUser.userRoleID) {
      this.http.get<GRSSResponse>(this.baseUrl + 'api/common/changeRole/' + role.id).subscribe(result => {
        if (result.statusCode == 1) {
          this.service.currentUser = undefined;
          const temp = new Promise((resolve, reject) => {
            this.service.CheckAuth().then(res => {
              if (res) {
                this.router.navigate([this.service.currentUser.defaultUrl]);
                resolve(true);
              } else {
                resolve(false);
              }
            });
          });
        }
      }, error => {
        console.error(error);
      });
    }
  }

  /**
   *  Gets the current time
   * @param seconds
   */
   GetTime(seconds: number) {
     this.service.checkCultureCookie();
     this.service.checkSidebarCookie(0);
    this.http.get<DateResponse>(this.baseUrl + 'api/common/getTime/' + seconds).subscribe(result => {
      if (result.needRefresh === true) {
        window.location.href = window.location.href;
      }
      this.currentTime = result.currentTime;
    });
  }

}

interface DateResponse {
  needRefresh: boolean;
  currentTime: string;
}
